import { Modal, Box } from "@mui/material";
import { IoMdClose } from "react-icons/io";
import CustomPagination from "../../../../../../components/table/CustomPagination";
import { ModalStyle } from "../../../../../../helpers/appHelpers";
import CustomStyledTable from "../../../../../../components/table/CustomStyledTable";
import { useManageTableWithStateVariables } from "../../../../../../helpers/useManageTable";
import { CountryDto, CountryInterestRateHistory } from "../../../../../../models/country.dto";
import { useGetCountryInterestRateHistory } from "../../../../../../services/country.service";
import { CountryInterestRateHistoryColumns } from "../data";

type CountryInterestRateHistoryModalProps = {
	country: CountryDto;
	openModal: boolean;
	setOpenModal: React.Dispatch<React.SetStateAction<boolean>>;
}

const CountryInterestRateHistoryModal = ({
	country,
	openModal,
	setOpenModal,
}: CountryInterestRateHistoryModalProps) => {
	const {
		tableAPIRef,
		tableData,
		isLoading,
		page,
		pageCount,
		handlePageChange,
	} = useManageTableWithStateVariables<CountryInterestRateHistory>({ 
		fetchHook: useGetCountryInterestRateHistory,
		options: { 
			countryId: country.id,
			orderBy: "timestamp:desc",
		}
	});

	return (
		<Modal
			open={openModal}
			aria-labelledby="modal-modal-title"
			aria-describedby="modal-modal-description"
		>
			<Box sx={ModalStyle} width={1260} fontSize={"13px"}>
				<div className="flex justify-between items-center pt-4 pb-6">
					<div className="flex items-center gap-5">
						<h1 className="font-bold text-lg">Interate Rate History</h1>
						<div className="bg-[#6978F0] font-semibold text-white whitespace-nowrap 
							text-xs px-2 py-[6px] rounded flex items-center justify-center"
						>
							{country.name}
						</div>
					</div>
					<button
						onClick={() => setOpenModal(false)}
					>
						<IoMdClose className="text-xl hover:scale-[1.1]" />
					</button>
				</div>
				<hr className="mb-6" />
				<CustomStyledTable
					rows={tableData}
					columns={CountryInterestRateHistoryColumns}
					apiRef={tableAPIRef}
					loading={isLoading}
					pageCount={pageCount}
					pagination={
						<CustomPagination 
							pageCount={pageCount} 
							pageState={page}
							handleChange={handlePageChange}
						/>
					}
				/>
			</Box>
		</Modal>
	);
};

export default CountryInterestRateHistoryModal;